interface Testimonial {
  name: string;
  role: string;
  quote: string;
  rating: number;
}

// Placeholder content — replace with real customer reviews before launch.
// Structure (name, role, quote, rating) is wired through to ReviewSchema
// in the same shape admin/content management will eventually edit.
const TESTIMONIALS: Testimonial[] = [
  {
    name: 'Local Business Owner',
    role: 'GST Registration',
    quote: 'The whole process was explained clearly and my registration was done faster than I expected.',
    rating: 5,
  },
  {
    name: 'Shop Owner',
    role: 'Trade License',
    quote: 'They handled all the paperwork for my trade license. I just had to provide documents.',
    rating: 5,
  },
  {
    name: 'Small Business Owner',
    role: 'MSME Registration',
    quote: 'Good support throughout, and the consultation call helped me understand exactly what I needed before committing.',
    rating: 5,
  },
];

export function Testimonials() {
  return (
    <section className="border-t border-line bg-white py-16">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="text-center">
          <p className="font-mono text-xs uppercase tracking-widest text-ledger-green">Customer Reviews</p>
          <h2 className="mt-2 font-display text-3xl font-bold text-ink">What Our Clients Say</h2>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <div key={i} className="rounded-lg border border-line bg-paper p-6">
              <div className="text-gold" aria-label={`${t.rating} out of 5 stars`}>
                {'★'.repeat(t.rating)}
              </div>
              <p className="mt-3 text-sm leading-relaxed text-ink/70">&ldquo;{t.quote}&rdquo;</p>
              <p className="mt-4 text-sm font-medium text-ink">{t.name}</p>
              <p className="text-xs text-ink/50">{t.role}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
